import $ from 'jquery'
import HelperCtrl from '@/inc/_helper'

const Helper = new HelperCtrl();
function CommonCtrl() {
	this.$naviContent = $('#gNaviContent')
	this.scrollCache = 0;
	this.timer = null;

	this.naviOpen = this.naviOpen.bind(this)
	this.naviClose = this.naviClose.bind(this)
	this.naviResize = this.naviResize.bind(this)
	this.init()
}

CommonCtrl.prototype.init = function () {
	$(document).on('click', '.btn-gnavi-open', this.naviOpen)
	$(document).on('click', '.btn-gnavi-close', this.naviClose)
	// $(window).on('resize', this.naviResize);
	// $('.btn-gnavi-toggle').on('click', function(e) {
	// 	// e.preventDefault();
	// 	e.stopPropagation();
	// })

	// $('.gnavi-content-scroll').on('click', function (e) {
	// 	e.preventDefault()
	// 	e.stopPropagation();
	// })

	// $('.gnavi-content-scroll a').on('click', function (e) {
	// 	// e.preventDefault()
	// 	e.stopPropagation();
	// })

	this.footerMobile()
	$('a[href="#top"]').on('click', this.pagetop)
	$('a[href^="#"]').on('click', this.smoothScroll)
}

// グロナビ
CommonCtrl.prototype.naviOpen = function () {
	this.$naviContent.addClass('actived');
	this.scrollCache = $(window).scrollTop()
	console.log('test');
	$('#wrap').css({
		height: 0,
		overflow: 'hidden',
	})
}

CommonCtrl.prototype.naviClose = function () {
	if (!this.$naviContent.hasClass('actived')) return;
	this.$naviContent.removeClass('actived');
	$('#wrap').css({
		height: 'auto',
		overflow: 'auto',
	})
	$(window).scrollTop(this.scrollCache)
}

CommonCtrl.prototype.naviResize = function () {
	clearTimeout(this.timer)
	this.timer = setTimeout(this.naviClose, 300)
}

CommonCtrl.prototype.footerMobile = function () {
	if( Helper.isMobile() ) {
		$('.foo-navi-heading').addClass('foo-navi-sp');
		$('.foo-navi-sp').on('click', function() {
			$(this).toggleClass('select');
			$(this).next('ul').slideToggle('fast');
		});
	}
}

CommonCtrl.prototype.pagetop = function (e) {
	e.preventDefault()
	$('html, body').animate({
		scrollTop: 0
	}, 500, 'linear')
}

CommonCtrl.prototype.smoothScroll = function (e) {
	e.preventDefault()
	var $self = $(e.currentTarget)
	var hash = $self.get(0).hash
	if (hash.match('#vc') || hash === '#spNavi' || hash === '#top') return;

	var $target = $(hash)
	var pos = $target.offset()
	$('body, html').animate({
		scrollTop: pos.top - 64
	}, 500, 'linear')
}

export default CommonCtrl